export default {
  getAccountStore: function (state) {
    return state.account
  },
  getPermissionRoleStore: function (state) {
    return state.permissionRole
  }
}
